import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { error } from "../../../theme/themePrimitives";

interface ResetRecordModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ResetRecordModal = ({
  open,
  onClose,
  onConfirm,
}: ResetRecordModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "544px",
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.24)",
          padding: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="h5" fontWeight="bold">
            Reset record
          </Typography>
          <IconButton sx={{ border: "none" }} onClick={onClose}>
            <CloseIcon sx={{ color: "#98A2B3" }} />
          </IconButton>
        </Box>

        <Typography
          variant="body2"
          color="error"
          sx={{ display: "flex", alignItems: "center", gap: "0.5rem", mb: 2 }}
        >
          <WarningAmberIcon sx={{ fontSize: "16px" }} />
          Are you sure you want to reset this record?
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Typography variant="body2" fontWeight={600} mb={0.5}>
          Important
        </Typography>
        <Typography variant="body2" mb={3}>
          This action cannot be undone.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5 }}>
          <Button
            onClick={onClose}
            sx={{
              px: 2,
              border: "1px solid #D0D5DD",
              borderRadius: "8px",
              backgroundColor: "white !important",
              color: "black",
              "&:hover": { backgroundColor: "whitesmoke !important" },
            }}
          >
            No, I don't want
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            sx={{
              px: 2,
              borderRadius: "8px",
              backgroundColor: `${error[600]} !important`,
              color: "white",
              "&:hover": { backgroundColor: `${error[700]} !important` },
            }}
          >
            Yes, I'm sure
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
